export const SUSDE_TOOLTIP =
  'Trailing one-week daily average of protocol return transferred into the staking rewards distributor contract, divided by average staked USDe each day, annualized with weekly compounding. This figure does not represent or guarantee future results.'
